import {useCallback, useEffect, useState} from 'react';
import screenfull from 'screenfull';

export const useFullscreen = () => {
  const [isFullScreenEnabled, setIsFullScreenEnabled] = useState(
    screenfull.isFullscreen
  );

  const toggle = useCallback(async () => {
    if (!screenfull.isEnabled) {
      // ToastManager.addToast({title: 'Fullscreen feature not supported'});
      console.log('Fullscreen feature not supported', 'ab in useFullScreen');
      return;
    }
    try {
      if (isFullScreenEnabled) {
        await screenfull.exit();
      } else {
        await screenfull.request();
      }
    } catch (err: any) {
      console.log(err.message, 'ab in useFullScreen');
      // ToastManager.addToast({title: err.message});
    }
  }, [isFullScreenEnabled]);

  useEffect(() => {
    const onChange = () => {
      setIsFullScreenEnabled(screenfull.isFullscreen);
    };
    if (screenfull.isEnabled) {
      screenfull.on('change', onChange);
    }
    return () => {
      if (screenfull.isEnabled) {
        screenfull.off('change', onChange);
      }
    };
  }, []);

  return {
    allowed: screenfull.isEnabled,
    isFullscreen: isFullScreenEnabled,
    toggleFullscreen: toggle,
  };
};
